import API_ENDPOINTS from '../api/endpoints';
import apiClient from '../api/apiClient';

export const createNotification = async (freelancerId) => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.NOTIFICATIONS.CREATE_NOTIFICATION, { freelancer_id: freelancerId });
    return response;
  } catch (error) {
    console.error("Subcription failed:", error);
    throw error;
  }
};


export const fetchNotifications = async () => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.NOTIFICATIONS.NOTIFICATIONS);
    return response.data; // Return only the data if that's all you need
  } catch (error) {
    console.error('Error fetching notifications:', error);
    throw error; // Re-throw the error for the caller to handle
  }
};

export const markNotificationAsRead = async (id) => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.NOTIFICATIONS.NOTIFICATIONS_READ(id));
    return response.data; // Return response data if needed
  } catch (error) {
    console.error("Error marking notification as read:", error);
    throw error; // Re-throw the error for the caller to handle
  }
};